import { render, staticRenderFns } from "./Roles.vue?vue&type=template&id=8cefd3d4&scoped=true"
import script from "./Roles.vue?vue&type=script&lang=js"
export * from "./Roles.vue?vue&type=script&lang=js"
import style0 from "./Roles.vue?vue&type=style&index=0&id=8cefd3d4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cefd3d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8cefd3d4')) {
      api.createRecord('8cefd3d4', component.options)
    } else {
      api.reload('8cefd3d4', component.options)
    }
    module.hot.accept("./Roles.vue?vue&type=template&id=8cefd3d4&scoped=true", function () {
      api.rerender('8cefd3d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/OrganisationDetails/Roles.vue"
export default component.exports